import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {LocalizationModule} from '@abp/ng.core';
import {LocalizedDatePipe} from '@shared/pipes/localized-date/localized-date.pipe';
import {DndModule} from 'ngx-drag-drop';


import {AlertService} from '@services/helpers/alert/alert.service';
import {LocalizeService} from '@services/helpers/localize/localize.service';
import {LocalizeTextPipe} from './pipes/localize-text/localize-text.pipe';

import {StorageService} from '@services/core/storage/storage.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    LocalizationModule,
    DndModule
],
  exports: [
  ],
  declarations: [],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LocalizedDatePipe,
        LocalizeTextPipe,
        AlertService,
        LocalizeService,
        StorageService,
      ],
    };
  }

  static forChild(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
